import { MDText } from 'i18n-react';

import type { VehicleData } from 'Pages/vehicles/helpers/vehicle.schema';

import { TextCTA } from '../../TextCTA/TextCTA';
import texts from '../BiddingSectionCTAStateController.texts';
import { getSaleType } from '../getSaleType';

const LocalT = new MDText(texts.biddingFrozen);

export const BiddingFrozen: React.FC<{ state: VehicleData['state'] }> = ({ state }) => {
	const saleType = getSaleType(state);

	return <TextCTA description={LocalT.translate('description')} title={LocalT.translate(`title.${saleType}`)} />;
};
